import * as Web3Utils from 'web3-utils';

export const content = {
  infoNoConnectedObj: {
    title: 'NO CONNECTED.',
    text: 'Please check your network or Metamask options.'
  },
  infoDeniedMemberObj: {
    title: 'ONLY MEMBERS CAN VIEW COMPANY PAGES.',
    text: 'Go to the home page and send a request to join the company today!'
  },
  infoOnlyOwnersObj: {
    title: 'NO ACCESS',
    text: ''
  },
  infoDeniedWaitingObj: {
    title: 'ONLY MEMBERS CAN VIEW COMPANY PAGES.',
    text: 'Please, wait the approving your request!'
  },
  infoDeniedBalanceObj: {
    title: 'THERE ARE NO YOUR SHARES.',
    text: 'If you want to be a member ask anyone to transfer you some shares!'
  },
  infoDeniedObj: {
    title: 'ONLY MEMBERS CAN VIEW COMPANY PAGES',
    text: 'Go to the home page and send a request to join the company today!'
  },
  defaultProfile: {
    name: 'Unknown user',
    avatar: 'https://img.icons8.com/windows/32/000000/gender-neutral-user.png'
  }
};
export const regular = {
  validate: {
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  }
};
export const empty = {
  web3: {
    bytes32: '0x',
    address: '0x0000000000000000000000000000000000000000'
  }
};
export const formatData = {
  systemDate: 'YYYY/MM/DD',
  systemDateTime: 'YYYY-MM-DDTHH:mm',
  date: 'DD/MM/YYYY',
  dateTime: 'DD/MM/YYYY hh:mm A ([GMT] Z)',
  certificateDate: 'MMMM Do YYYY',
  number: (data, maximumFractionDigits = 3) => {
    if (isNaN(+data)) return '0';
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits
    }).format(data);
  },
  fromSatoshiToBTC: satoshi => satoshi / 100000000,
  fromWei: value => Web3Utils.fromWei(value.toString()),
  toETHFormat: (value, maximumFractionDigits = 7, isxDaiNetwork = false) => `${formatData.number(value, maximumFractionDigits)} ${!isxDaiNetwork ? 'ETH' : 'USD' }`,
  toTokenFormat: (value, token) => `${formatData.number(value, 7)} ${token.toUpperCase()}`
};
export const errors = {
  backend: {
    status: {
      serverDown: {
        infoText: 'Backend server is not available. Please try later.'
      },
      ipfsDown: {
        statusCode: 503,
        statusText: 'Service Unavailable',
        infoText: 'File service is not available. Please try later.'
      }
    }
  }
};
export const EMAIL_SELECT = [
  { value: null, text: 'Please select ...', disabled: true },
  { value: 'agent', text: 'Agent' },
  { value: 'support', text: 'Support Team' }
];
